module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0013.jpg?v=2c3ab0ea";